import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTiktok,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { FaSnapchat } from "react-icons/fa6";
import { FiClock, FiMail, FiPhone, FiYoutube, FiMapPin } from "react-icons/fi";
import { Row, Col } from "antd";
import mada from "../../../styles/images/mada.svg";
import mc from "../../../styles/images/mc.svg";
import qitaf from "../../../assets/qitafImage.png";
import baseeta from "../../../assets/baseeta-logo.png";
import Visa from "../../../styles/images/visa.svg";
import mylist from "../../../styles/images/mylist.png";
import youGota from "../../../styles/images/yougotagift.png";
import mokafaa from "../../../styles/images/rajhi.png";
import tabi from "../../../styles/images/tabby2.png";
interface FooterProps {
  type?: "internal" | "external";
}

const Footer = ({ type }: FooterProps) => {
  const { t, i18n } = useTranslation();
  const date = new Date().getFullYear();
  const getLink = (index: number) => {
    switch (index) {
      case 1:
        return "/loyalty-program";
      case 2:
        return "/our-partners";
      case 3:
        return "/news";
      case 4:
        return "/contact-us";
      case 5:
        return "/jobs";
      case 6:
        return "/return-policy";
      case 7:
        return "/warranty";
      case 8:
        return "/terms-conditions";
      case 9:
        return "/privacy-policy";
      case 10:
        return "/faq";

      default:
        return "/";
    }
  };

  return (
    <footer className={`footer ${"ac--footer-external"}`}>
      <div className="container">
        <Row gutter={[16, 16]}>
          {/* First Column - Logo and Description */}
          <Col xs={24} sm={12} md={6} lg={8}>
            <div className="mb-20">
              <a className="d-flex" href="index.html">
                <img
                  className="light-mode"
                  alt=""
                  src={`${"assets/imgs/template/logo-w.svg"}`}
                />
              </a>
              <div className="box-info-contact mt-20">
                <p className={`text-md ${"text-white"}`}>
                  {t("footer.description")}
                </p>
              </div>
            </div>
          </Col>

          {/* Second Column - Contact Info */}
          <Col xs={24} sm={12} md={6} lg={10}>
            <div className="mb-20">
              <h6
                className={`text-linear-3 ${
                  i18n.language === "ar" ? "ac--font-expo" : ""
                } ${"text-white"}`}
              ></h6>

              <div className="box-info-contact mt-20">
                <div
                  className={`text-md ${"text-white"} mt-20 d-flex align-items-center`}
                >
                  <div className="ac--footer-icon-container">
                    <FiPhone aria-hidden="true" />
                  </div>
                  <a
                    href="tel:920008980"
                    dir="ltr"
                    className={i18n.language === "en" ? `ps-3` : "pe-3"}
                    style={{ color: "white" }}
                  >
                    920008980
                  </a>
                </div>

                <div className="text-md text-white mt-20 d-flex align-items-center">
                  <div className="ac--footer-icon-container">
                    <FiMail aria-hidden="true" />
                  </div>
                  <a
                    href="mailto:info@autochapeau.com"
                    className={i18n.language === "en" ? "ps-3" : "pe-3"}
                    style={{ color: "white" }}
                  >
                    info@autochapeau.com
                  </a>
                </div>

                <div
                  className={`text-md ${"text-white"} d-flex align-items-center mt-20`}
                >
                  <div className="ac--footer-icon-container">
                    <FiClock aria-hidden="true" />
                  </div>
                  <Link
                    to="/our-branches"
                    className={i18n.language === "en" ? "ps-3 text-white" : "pe-3 text-white"}
                  >
                    {t("footer.time")}
                  </Link>
                </div>
                <div className="text-md text-white d-flex align-items-start mt-20">
                  <div className="ac--footer-icon-container">
                    <FiMapPin aria-hidden="true" />
                  </div>
                  <span className={i18n.language === "en" ? "ps-3" : "pe-3"}>
                    {t("footer.nationalAddress")}
                  </span>
                </div>
              </div>
            </div>
            <div
              className={`text-md ${"text-white"}`}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                marginTop: "2rem",
              }}
            >
              <div className="icon-container">
                <Link
                  to="https://www.facebook.com/autochapeau/"
                  className="icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookF />
                </Link>
                <Link
                  to="https://www.instagram.com/autochapeau/"
                  className="icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </Link>
                <Link
                  to="https://x.com/autochapeau"
                  className="icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span
                    style={{
                      fontFamily: "Arial, sans-serif",
                      fontWeight: "bold",
                    }}
                  >
                    X
                  </span>
                </Link>
                <Link
                  to="https://www.youtube.com/@autochapeau/featured"
                  className="icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiYoutube />
                </Link>
                <Link
                  to="https://www.tiktok.com/@autochapeau"
                  className="icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTiktok />
                </Link>
                <Link
                  to="https://www.snapchat.com/add/autochapeau"
                  className="icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaSnapchat />
                </Link>
                <Link
                  to="https://www.linkedin.com/company/autochapeau/"
                  className="icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedinIn />
                </Link>
              </div>
            </div>
          </Col>

          {/* Third Column - First set of links */}
          <Col xs={12} sm={12} md={6} lg={3}>
            <h6
              className={`text-linear-3 ${
                i18n.language === "ar" ? "ac--font-expo" : ""
              } ${"text-white"}`}
            ></h6>
            <ul className={`menu-footer ${"menu-footer-external"}`}>
              {[1, 2, 3, 4, 5].map((index) => (
                <li
                  className={`${
                    i18n.language === "ar" ? "ac--font-expo" : ""
                  } text-white`}
                  key={index}
                >
                  <Link to={getLink(index)}>
                    {t(`footer.blocks.1.items.${index}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Fourth Column - Second set of links */}
          <Col xs={12} sm={12} md={6} lg={3}>
            <h6
              className={`text-linear-3 ${
                i18n.language === "ar" ? "ac--font-expo" : ""
              } ${"text-white"}`}
            ></h6>
            <ul className={`menu-footer ${"menu-footer-external"}`}>
              {[6, 7, 8, 9, 10].map((index) => (
                <li
                  className={`${
                    i18n.language === "ar" ? "ac--font-expo" : ""
                  } text-white text-nowrap`}
                  key={index}
                >
                  <Link to={getLink(index)}>
                    {t(`footer.blocks.1.items.${index}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </div>
      {/* Payment Methods  */}
      <div
        className="payment-methods-container"
        style={{
          backgroundColor: "#f5f5f5",
          padding: "2px 0",
          marginTop: "30px",
          borderTop: "1px solid #e0e0e0",
          borderBottom: "1px solid #e0e0e0",
          alignItems: "center",
        }}
      >
        <Row justify="center" gutter={[16, 16]}>
          <Col style={{ alignItems: "center", display: "flex" }}>
            <div className="payment-icon" style={{ padding: "8px" }}>
              <img
                src={mylist}
                alt="mylist"
                style={{
                  height: "55px",
                  width: "68px",
                  filter: "grayscale(100%) brightness(85%) contrast(90%)",
                }}
              />
            </div>
          </Col>
          <Col style={{ alignItems: "center", display: "flex" }}>
            <div
              className="payment-icon"
              style={{ alignItems: "center", padding: "8px" }}
            >
              <img
                src={youGota}
                alt="youGota"
                style={{
                  height: "66px",
                  width: "67px",
                  filter: "grayscale(100%) brightness(85%) contrast(90%)",
                }}
              />
            </div>
          </Col>
          <Col style={{ alignItems: "center", display: "flex" }}>
            <div className="payment-icon" style={{ padding: "8px" }}>
              <img
                src={mokafaa}
                alt="mokafaa"
                style={{
                  height: "44px",
                  width: "100px",
                  filter: "grayscale(100%) brightness(85%) contrast(90%)",
                }}
              />
            </div>
          </Col>
          <Col style={{ alignItems: "center", display: "flex" }}>
            <div className="payment-icon" style={{ padding: "8px" }}>
              <img
                src={qitaf}
                alt="qitaf"
                style={{
                  height: "62px",
                  width: "62px",
                  filter: "grayscale(100%) brightness(85%) contrast(90%)",
                }}
              />
            </div>
          </Col>
          <Col style={{ alignItems: "center", display: "flex" }}>
            <div className="payment-icon" style={{ padding: "8px" }}>
              <img
                src={tabi}
                alt="tabi"
                style={{
                  height: "40px",
                  width: "100px",

                  filter: "grayscale(100%) brightness(85%) contrast(90%)",
                }}
              />
            </div>
          </Col>
          <Col style={{ alignItems: "center", display: "flex" }}>
            <div className="payment-icon" style={{ padding: "8px" }}>
              <img
                src={baseeta}
                alt="baseeta"
                style={{
                  height: "55px",
                  width: "100px",

                  filter: "grayscale(100%) brightness(85%) contrast(90%)",
                }}
              />
            </div>
          </Col>
          <Col style={{ alignItems: "center", display: "flex" }}>
            <div className="payment-icon" style={{ padding: "8px" }}>
              <img
                src={mc}
                alt="mc"
                style={{
                  height: "55px",
                  width: "100px",

                  filter: "grayscale(100%) brightness(85%) contrast(90%)",
                }}
              />
            </div>
          </Col>
          <Col style={{ alignItems: "center", display: "flex" }}>
            <div className="payment-icon" style={{ padding: "8px" }}>
              <img
                src={Visa}
                alt="Visa"
                style={{
                  height: "55px",
                  width: "100px",

                  filter: "grayscale(100%) brightness(85%) contrast(90%)",
                }}
              />
            </div>
          </Col>
          <Col style={{ alignItems: "center", display: "flex" }}>
            <div className="payment-icon" style={{ padding: "8px" }}>
              <img
                src={mada}
                alt="mada"
                style={{
                  height: "55px",
                  width: "100px",

                  filter: "grayscale(100%) brightness(85%) contrast(90%)",
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
      {/* Footer Bottom */}
      <div>
        <div className="ac--footer-bottom-page-container">
          <div className="ac--footer-bottom-page">
            <p className={`ac--font-jfbold ${"color-white"}`}>
              <span> {t("footer.campany")} </span>
              <span className="ml-25"> | </span>
              <span className="ml-25"> {t("footer.unifiedNumber")}</span>
              <span className="ml-25"> | </span>
              <span className="ml-25"> {t("footer.vatNumber")}</span>
            </p>
            <p className={`ac--font-jfbold ${"color-white"}`}>
              {t("footer.copyright")} © {date}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
